import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';

const BreadcrumbSchema = ({ textes }) => {
  const [currentSection, setCurrentSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      const sections = [
        { id: 'home', element: null, position: 0 },
        { id: textes?.navBarItem2?.toLowerCase(), element: null, position: 0 },
        { id: textes?.navBarItem1?.toLowerCase(), element: null, position: 0 },
        { id: 'projects', element: null, position: 0 },
        { id: 'studio-creation', element: null, position: 0 },
        { id: 'wework-brands', element: null, position: 0 },
        { id: 'wework-agencies', element: null, position: 0 },
        { id: 'wework-associations', element: null, position: 0 },
        { id: 'contact', element: null, position: 0 }
      ];

      // Get section positions
      sections.forEach(section => {
        const element = document.getElementById(section.id);
        if (element) {
          section.position = element.offsetTop;
        }
      });

      const scrollPosition = window.scrollY + 100; // Offset for better detection

      // Find current section
      let current = sections[0];
      for (let i = sections.length - 1; i >= 0; i--) {
        if (scrollPosition >= sections[i].position) {
          current = sections[i];
          break;
        }
      }

      setCurrentSection(current.id);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial call

    return () => window.removeEventListener('scroll', handleScroll);
  }, [textes]);

  // Generate breadcrumb list based on current section
  const generateBreadcrumbList = () => {
    const baseUrl = 'https://studio-sam.fr';
    const breadcrumbs = [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": baseUrl
      }
    ];

    switch (currentSection) {
      case textes?.navBarItem2?.toLowerCase():
        breadcrumbs.push({
          "@type": "ListItem",
          "position": 2,
          "name": textes?.navBarItem2 || "About",
          "item": `${baseUrl}#${textes?.navBarItem2?.toLowerCase()}`
        });
        break;
      case textes?.navBarItem1?.toLowerCase():
        breadcrumbs.push({
          "@type": "ListItem",
          "position": 2,
          "name": textes?.navBarItem1 || "Work",
          "item": `${baseUrl}#${textes?.navBarItem1?.toLowerCase()}`
        });
        break;
      case 'projects':
        breadcrumbs.push(
          {
            "@type": "ListItem",
            "position": 2,
            "name": textes?.navBarItem1 || "Work",
            "item": `${baseUrl}#${textes?.navBarItem1?.toLowerCase()}`
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "Projects",
            "item": `${baseUrl}#projects`
          }
        );
        break;
      case 'studio-creation':
        breadcrumbs.push(
          {
            "@type": "ListItem",
            "position": 2,
            "name": textes?.navBarItem1 || "Work",
            "item": `${baseUrl}#${textes?.navBarItem1?.toLowerCase()}`
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "Studio Creation",
            "item": `${baseUrl}#studio-creation`
          }
        );
        break;
      case 'wework-brands':
      case 'wework-agencies':
      case 'wework-associations':
        breadcrumbs.push(
          {
            "@type": "ListItem",
            "position": 2,
            "name": "We Work With",
            "item": `${baseUrl}#wework-brands`
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": currentSection.replace('wework-', '').replace('-', ' ').replace(/\b\w/g, l => l.toUpperCase()),
            "item": `${baseUrl}#${currentSection}`
          }
        );
        break;
      case 'contact':
        breadcrumbs.push({
          "@type": "ListItem",
          "position": 2,
          "name": "Contact",
          "item": `${baseUrl}#contact`
        });
        break;
      default:
        // Home page - no additional breadcrumbs needed
        break;
    }

    return breadcrumbs;
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": generateBreadcrumbList()
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </Helmet>
  );
};

export default BreadcrumbSchema;